import { Inject, Injectable } from '@angular/core';
import { filter, map, Observable } from 'rxjs';

import {
  DynamicFormExtension,
  DynamicFormsExtensionsService,
} from '@lockton-apps/dynamic-forms';
import { CastObservablePipe } from '@lockton-apps/shared/ui/pipes';
import { PROPOSAL_PARTNER_DATA } from '../../constants/proposal-partner-data';
import { ProposalProductDetailsComponent } from '@lockton-apps/shared/ui/proposal-product-details';
import {
  DocumentsService,
  SupportingDocumentsService,
} from '@lockton-apps/shared/data-access/documents';
import { FeedbackService } from '@lockton-apps/shared/ui/lui';

interface PartnerData {
  proposalId: string | undefined;
  createdDate: string;
  availableAddonCobs: number[];
}

@Injectable()
export class RegulatoryDynamicFormsExtensionsService extends DynamicFormsExtensionsService {
  override extensions: DynamicFormExtension[] = [
    {
      id: 'professionalAssociations',
      prop: 'options',
      value: [
        {
          label: 'LIB',
          value: 'LIB',
        },
        {
          label: 'BIBA',
          value: 'BIBA',
        },
        {
          label: 'Other',
          value: 'Other',
        },
      ],
    },
    {
      id: 'productDetails',
      prop: 'component',
      value: ProposalProductDetailsComponent,
    },
    {
      id: 'productDetailsInputs',
      prop: 'inputs',
      value: '',
      mappedValue: () => ({
        cobs: this.partnerData$.pipe(
          filter(Boolean),
          map(({ availableAddonCobs }) => availableAddonCobs)
        ),
      }),
    },
  ];

  constructor(
    @Inject(PROPOSAL_PARTNER_DATA)
    protected readonly partnerData$: Observable<PartnerData>,
    castObservable: CastObservablePipe,
    documentsService: DocumentsService,
    supportingDocumentsService: SupportingDocumentsService,
    feedbackService: FeedbackService
  ) {
    super(
      castObservable,
      documentsService,
      supportingDocumentsService,
      feedbackService
    );
  }
}
